import Cook from './api'
import { CookiesStatic } from './js-cookie'

export const Cookie: CookiesStatic = Cook
